<button type="button" class="tile" [attr.aria-label]="title" (click)="navigateToLink($event)">
  <div class="tile__body">
    <div class="tile__title">{{ title }}</div>
    <div class="tile__description">{{ description }}</div>
  </div>
  <div class="tile__cta btn_primary" [ngClass]="{'tile__cta--bordered': isBordered}" aria-hidden="true">
    <span class="tile__cta-label">{{ linkLabel }}</span>
    <span class="tile__cta-arrow">
      <svg viewBox="0 0 20 20" focusable="false" aria-hidden="true">
        <path d="M10.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414Z" fill="currentColor"/>
      </svg>
    </span>
  </div>
</button>